import Cookies from 'js-cookie';

import {
  COOKIE_LOGOUT_PATH,
  COOKIE_TOKEN,
} from '@shared-web/constants/cookies';
import { isDevMode, isProdApp, isTestMode } from '@shared-web/constants/env';
import {
  SUB_ACCOUNT_TRADE_UUID,
  SUB_ACCOUNT_UUID,
} from '@shared-web/constants/storage';
import { FULL_BASE_URL } from '@shared-web/utils/path';

import { removeCustomCookie, setCustomCookie } from './cookie';

export const cookieDomain =
  isDevMode || isTestMode ? '' : isProdApp ? '.crypto.com' : '.3ona.co';

export function clearSession(logoutPath = '') {
  removeCustomCookie(COOKIE_TOKEN);
  sessionStorage.removeItem(SUB_ACCOUNT_UUID);
  sessionStorage.removeItem(SUB_ACCOUNT_TRADE_UUID);

  if (isProdApp) {
    Cookies.remove(COOKIE_TOKEN); // in some edge cases, 'token' will exist in 'crypto.com' domain
  }

  setCustomCookie(COOKIE_LOGOUT_PATH, FULL_BASE_URL + logoutPath);
}
